import * as React from 'react'
import { cn } from '@/lib/utils'

export interface TextareaProps extends React.ComponentPropsWithRef<'textarea'> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => (
  <textarea
    className={cn(
      `ui-min-h-[96px] ui-w-full ui-rounded-xl ui-border ui-border-gray-200 ui-bg-white ui-p-4 ui-text-sm ui-leading-relaxed ui-text-gray-900 ui-ring-offset-background placeholder:ui-text-gray-400 focus-visible:ui-outline-none focus-visible:ui-ring-1 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-1 disabled:ui-cursor-not-allowed disabled:ui-opacity-60`,
      className
    )}
    ref={ref}
    {...props}
  />
))
Textarea.displayName = `Textarea`

export { Textarea }
